import { render, staticRenderFns } from "./checkbox-raw-label.vue?vue&type=template&id=c21163e2"
import script from "./checkbox-raw-label.vue?vue&type=script&lang=js"
export * from "./checkbox-raw-label.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports